import React, { useState } from "react";

function Exprincevd() {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <>
      <div className="tp-video-area bg-position jarallax p-relative">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="tp-video-three-wrap tp-video-three-spacing text-center">
                <div
                  className="tp-video-main mb-45"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <button
                    onClick={() => setShowPopup(true)}
                    className="tp-video-three-play tp-pulse-border p-relative"
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    <svg
                      width="23"
                      height="26"
                      viewBox="0 0 23 26"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M23 13L0.5 25.9904V0.00961876L23 13Z"
                        fill="#FAF5EF"
                      />
                    </svg>
                  </button>
                </div>
                <h3 className="text-white tp-video-title text-white text-[24px] sm:text-[22px] md:text-[32px] lg:text-[36px] font-semibold leading-snug" style={{color:"white"}}>
                  Experience The{" "}
                  <a href="#" className="underline">
                    Process Of
                  </a>
                  <br /> Flower Recycling
                </h3>
              </div>
            </div>
          </div>
        </div>

        <div className="tp-video-great-work">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-video-great-content text-center">
                  <p className="bottom-txt text-white" >
                    Proudly <span style={{fontWeight:"bold"}}> Recycling 4000+ kg </span>of Flowers Daily
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Popup Overlay */}
        {showPopup && (
          <div
            style={{ backgroundColor: "rgb(24 127 67 / 62%)" }}
            className="fixed inset-0 bg-opacity-70 flex items-center justify-center z-50"
            onClick={() => setShowPopup(false)}
          >
            <div
              className="relative bg-black  rounded-lg"
              style={{ maxWidth: "90%", maxHeight: "90%" }}
              onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside video
            >
              <iframe
                style={{ borderRadius: "25px" }}
                width="560"
                height="315"
                src="https://www.youtube.com/embed/uhuVFtUXuZY?autoplay=1"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
              <button
                onClick={() => setShowPopup(false)}
                className="absolute top-2 right-2 text-white text-2xl"
              >
                &times;
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Exprincevd;
